module.exports = __webpack_public_path__ + "img/passenger.f923244d.svg";